import { API_LOGIN_USING_SAML } from "consts";
import { useMutation } from "react-query";
import httpClient from "utils/http-client";

const postSamlRequest = (body) => httpClient.post(API_LOGIN_USING_SAML, body);
export const useSAMLReqest = () => useMutation(postSamlRequest);
